<header class="header fixed-top">
	<div class="container position-relative">
		<a class="logo" href="#">
			<img src="assets/img/logo/logo.png" width="112" alt="silgov" />
		</a>
		@if (!isMenuOpen) {
			<button class="hamburger" (click)="toggleMenu()" [class.open]="isMenuOpen" aria-label="Open Menu">
				<span></span>
				<span></span>
				<span></span>
			</button>
		}

		@if (isMenuOpen) {
			<button class="close-menu" (click)="closeMenu()" aria-label="Close Menu">&times;</button>
		}

		<nav [class.open]="isMenuOpen">
			<div class="d-lg-none">
				<img src="assets/img/logo/logo-blank.png" class="top-10 start-0 end-0 mx-auto position-absolute" width="150" alt="silgov" />
			</div>

			<ul>
				<li><a [href]="'processes'" (click)="closeMenu()">Processos</a></li>
				<li><a [href]="'#features'" (click)="closeMenu()">Soluções</a></li>
				<li>
					<a [routerLink]="urlState | async" [queryParams]="{ action: 'login' }" class="d-lg-none get-start" (click)="closeMenu()">
						Cadastrar | Acessar
					</a>
				</li>
			</ul>
		</nav>
		<div class="d-lg-block d-none">
			@if (authService.expired) {
				<a [routerLink]="urlState | async" [queryParams]="{ action: 'login' }" class="get-start text-decoration-none me-3" (click)="closeMenu()">
					Cadastrar | Acessar
				</a>
			} @else {
				<li class="nav-item dropdown no-caret me-3 me-lg-0 dropdown-user" ngbDropdown [placement]="'bottom-end'" display="dynamic">
					<a
						class="btn border-1 border-gray-500 btn-icon shadow-left-sm btn-transparent-dark dropdown-toggle"
						id="navbarDropdownUserImage"
						ngbDropdownToggle
						data-cy="userMenu"
						role="button"
						aria-haspopup="true"
						aria-expanded="false">
						<button class="btn fw-500 rounded-xl bg-gray-100">
							{{ slugName$ | async }}
						</button>
					</a>

					<div class="dropdown-menu border-0 shadow animated--fade-in-up" ngbDropdownMenu aria-labelledby="dropdownUser">
						<h6 class="dropdown-header d-flex flex-column">
							@if (authService.user$ | async; as user) {
								<div class="dropdown-user-details">
									<div class="dropdown-user-details-name">
										{{ user.name }}
									</div>
									<div class="dropdown-user-details-email">{{ user.email }}</div>
								</div>

								<div class="dropdown-divider"></div>

								<a class="dropdown-item ps-2" (click)="redirectSession()">
									<div class="dropdown-item-icon">
										<i-feather name="list"></i-feather>
									</div>
									Meus Processos
								</a>

								<button class="dropdown-item ps-2" (click)="authService.logout()" [disabled]="authService.logoutSubmitted">
									<div class="dropdown-item-icon">
										<i-feather name="log-out"></i-feather>
									</div>
									{{ authService.logoutSubmitted ? 'Aguarde...' : 'Sair' }}
								</button>
							}
						</h6>
					</div>
				</li>
			}
		</div>
	</div>
</header>
